/** Misc scenarios migrated to v2 (excluding Create Scenario → custom-scenario). */
module.exports = {
  "When Galaxies Collide":
    "galaxies-and-globular-clusters/when-galaxies-collide",
  "Earth Spoils the Rings of Saturn":
    "what-if/earth-versus-the-rings-of-saturn",
  "How Trojan Asteroids Come to Be":
    "what-if/giant-planet-in-a-debris-ring",
};
